export class Sources {
	checked: number;
	count: number;
	novedad: string;
	resultado: boolean;
}
